import React from "react";
import styled from "styled-components";
import i18n from '../../../i18n';
import { Navbar } from "../Navbar";
import HomepageFooter from '../Footers/HomepageFooter';
import { useTranslation } from "react-i18next";
import { useMediaQuery } from 'react-responsive'
import { Container, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export const JoinUsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  margin-right: 80px;
  padding: 0 1.5em;
  background-color: #fff;
  white-space: pre-line;
  fontFamily: "Noto Sans",
`;

const TitleText = styled.div`
  height: 100%;
  padding: 0 1.1em;
  color: #53B0AE;
  font-weight: bold;
  font-size: 24px;
  align-items: center;
  justify-content: center;
  display: flex;
  fontFamily: "Noto Sans",
`;

const SubTitleText = styled.div`
  height: 100%;
  padding: 0 1.1em;
  color: #53B0AE;
  font-weight: bold;
  font-size: 20px;
  align-items: center;
  justify-content: center;
  display: flex;
  fontFamily: "Noto Sans",
`;

const ContentText = styled.div`
  height: 100%;
  padding: 0 1.1em;
  color: #191919;
  font-weight: 300;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  display: flex;
  fontFamily: "Noto Sans",
`;

const FormButton = styled.button`
  border: 0;
  outline: 0;
  width: 200px;
  padding: 8px 1em;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 18px;
  background-color: #53B0AE;
  cursor: pointer;
`;


export function JoinUs(props) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({
    query: '(max-width: 992px)'
  })
  return (
    <div>
      <Navbar />
        <div style={{marginTop: 120}}/>
        <JoinUsContainer>
        <TitleText>{t('join_us')}</TitleText>
        <br/><br/>
        <ContentText>{t('join_us_content1')}</ContentText>
        <ContentText>{t('join_us_content2')}</ContentText>
        <ContentText>{t('join_us_content3')}</ContentText>
        <ContentText>{t('join_us_content4')}</ContentText>

        <br/><br/><br/>
        <SubTitleText>{t('events')}</SubTitleText>
        <br/>
        <ContentText>{t('join_us_event_hint')}</ContentText>
        <br/>
        <ContentText><a target="_blank" href="https://form.jotform.com/212102463382041"><FormButton>{t('upload_event')}</FormButton></a></ContentText>
        <br/>
        <ContentText><a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLScyeHBTIagaKwkeCpcxAYxcdeNduQBp5aoNl83M5C35rElHbQ/viewform"><FormButton>{t('apply_event_system')}</FormButton></a></ContentText>

        <br/><br/><br/>
        <SubTitleText>{t('studios')}</SubTitleText>
        <br/>
        <ContentText>{t('join_us_studio_hint')}</ContentText>
        <br/>
        <ContentText><a target="_blank" href="https://zj1a6ljriso.typeform.com/to/o9pFUqQ0"><FormButton>{t('apply_studio_system')}</FormButton></a></ContentText>
        <br/><br/><br/>
        <SubTitleText>{t('advertisement')}</SubTitleText>
        <br/>
        <ContentText>{t('join_us_advertisement_hint')}</ContentText>
        <ContentText>{t('join_us_advertisement_hint2')}</ContentText>
        <br/>
        <ContentText><a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLScyeHBTIagaKwkeCpcxAYxcdeNduQBp5aoNl83M5C35rElHbQ/viewform?fbzx=-6000503359185332248"><FormButton>{t('apply_advertisement')}</FormButton></a></ContentText>
        </JoinUsContainer>
        <div style={{marginBottom: 100}}/>
      <HomepageFooter />
    </div>
  );
}
